<template>
<div>
	<div v-if="showReportIssueForm" class="issue-form">
		<div class="form-control-group">
			<label class="form-control" for="problem">Describe the issue:</label>
			<textarea id='problem' v-model='content' @keyup="keyDataChanged" class="form-control" rows=4></textarea>
			<div v-if='dataEntered' class="issue-help">{{characterCountMessage}}</div>
			<div class="form-control-group pull-right">
				<button @click.prevent="cancel" class="btn btn-sm btn-default">Cancel</button>
				<button @click.prevent="submitForm" class="btn btn-sm btn-danger pull-right">Submit</button>
			</div>
		</div>
	</div>
	<div class="text-center">
		<button v-if="showReportIssueButton" @click.prevent="revealForm" class="btn btn-sm btn-danger center">Report an Issue</button>
	</div>
	<modal v-if="showModal"  @close="showModal = false">
		<span slot="header"></span>
		<div slot="body">{{ message }}</div>
	</modal>
</div>

</template>

<script>

export default {

  name: 'report-issue',

  methods: {

  	revealForm() {
  		this.showReportIssueForm = true;
  	},

  	cancel(){
  		this.showReportIssueForm=false
  		this.content = ''
  	},

  	keyDataChanged(){
  		var charCount = this.content.length
  		if(charCount < this.minCharCount){
  			this.characterCountMessage = (this.minCharCount - charCount) + " charcters more to meet minimum"
  		} else if (charCount >= this.minCharCount && charCount <= this.maxCharCount) {
  			this.characterCountMessage = (this.maxCharCount - charCount) + " characters left"
  		} else {
  			this.characterCountMessage = (charCount - this.maxCharCount) + " characters overbudget"
  		}
  	},

  	submitForm() {
  		var data = new FormData()
  		var self = this
  		data.append('issue', this.content);
  		data.append('href', window.location.href)

  		axios.post('/beta/report-issue',data)
  		.then(function(response){
  			console.log(response.data)
  			self.showReportIssueForm = false;
  			if (response.data.status == 'success') {
  				self.content=''
  				self.showReportIssueForm = false
          UWEvent.fire('IssueSubmitted', response.data.issue)
  			}
  			self.showResults(response.data.msg)
  		})
  		.catch(function(error){
  			console.log(error.response)
  			if (error.response.status == 422){
  				self.showResults(JSON.stringify(error.response.data.issue[0]))
  			} else {
  			self.showResults('It seems something has gone wrong, if the problem persists, please contact your adminstrator through conventional means...')
  			}
  		})

  	},

  	showResults(msg){
  		this.message = msg;
  		this.showModal = true
  		console.log(msg)
  	},


  },

  computed: {

  	showReportIssueButton : function() {
  		return ! this.showReportIssueForm;
  	},

  	dataEntered : function(){
  		return (this.content.length > 0)
  	}, 
  },

  data () {
    return {
    	minCharCount: 10,
    	maxCharCount: 180,
    	showModal: false,
    	showReportIssueForm: false,
    	message: 'default message',
    	content: '',
    	characterCountMessage: '',

    };
  }
};
</script>

<style lang="css" scoped>
</style>